<template>
  <div class="modal fade" id="edit-store-basic-modal" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-map mr-5"></i>{{'store_address' | translate}}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12"><h5>{{ 'basic_info' | translate }}:</h5></div>
            <div class="col-sm-6 col-xs-12">
              <div class="form-group">
                <label for="shop_name">{{ 'store_name' | translate }}:</label>
                <input id="shop_name" v-validate="{required: true}" v-model="address.corrected_name" placeholder="Filialname" type="text" class="form-control">
              </div>
            </div>
            <div class="col-sm-6 col-xs-12">
              <div class="form-group">
                <label for="contact_name">{{'contact_name' | translate}}:</label>
                <input id="contact_name" v-validate="{required: true}" v-model="address.corrected_contact_name" placeholder="Kontakt Name" type="text" class="form-control">
              </div>
            </div>
            <div class="col-sm-6 col-xs-12">
              <div class="form-group">
                <label for="order_email">{{'order_email' | translate}}:</label>
                <input id="order_email" data-vv-as="Kontakt Email" v-validate="{required: true}" v-model ="address.corrected_order_email" name="order_email" placeholder="Bestell-Email" type="text" class="form-control" data-vv-id="1" aria-required="true" aria-invalid="false">
                <span class="small text-danger" style="display: none;"></span>
              </div>
            </div>
            <div class="col-sm-6 col-xs-12">
              <div class="form-group">
                <label for="contact_email">{{'contact_email' | translate}}:</label>
                <input id="contact_email" data-vv-as="Kontakt Email" v-validate="{required: true}" v-model="address.corrected_contact_email" name="contact_email" placeholder="Kontakt-Email" type="text" class="form-control" data-vv-id="1" aria-required="true" aria-invalid="false">
                <span class="small text-danger" style="display: none;"></span>
              </div>
            </div>
            <div v-if="sde1Active()" class="col-sm-6 col-xs-12">
              <div class="form-group">
                <label for="click_collect_email">Click&amp;Collect-Email:</label>
                <input id="click_collect_email" data-vv-as="Kontakt Email"  v-validate="{required: true, regex: '^(\\s*[^\\s,]+@[^\\s,]+\\.[^\\s,]+\\s*,?)*$'}"  v-model="address.corrected_click_collect_email" name="click_collect_email" placeholder="Click&amp;Collect-Email" type="text" class="form-control" data-vv-id="2" aria-required="true" aria-invalid="false">
                <span class="small text-danger" style="display: none;"></span>
              </div>
            </div>
            <div class="col-sm-6 col-xs-12">
              <div class="form-group">
                <label for="contact_phone">{{'contact_phone' | translate}}:</label>
                <input id="contact_phone" v-model="address.corrected_contact_phone"  v-validate="{required: true}" placeholder="Kontakt Telefon" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-xs-12">
              <div class="form-group">
                <label for="mobile">ERP Store ID*:</label>
                <input class="form-control" v-model="address.corrected_erp_store_id" id="mobile" v-validate="{required: true}" placeholder="ERP Store ID" type="text" value="504">
              </div>
            </div>
            <div class="col-md-6 col-xs-12">
              <div class="form-group">
                <label>{{'stores' | translate}}-Ranking:</label>
                <select class="form-control"  v-validate="{required: true}" name="rank" v-model="address.corrected_ranking">
                  <template v-for="n in $store.getters.stores.length">
                    <option :value="n" :key="n.id" class="normal">{{n}}</option>
                  </template>
                </select>
              </div>
            </div>
            <div class="col-xs-12"><h5>{{'store_address' | translate}}:</h5></div>
            <div class="col-sm-9 col-xs-12">
              <div class="form-group">
                <label for="street">{{'shipping_street' | translate}}:</label>
                <input id="street" v-model="address.corrected_street" v-validate="{required: true}" placeholder="Straße" type="text" class="form-control">
              </div>
            </div>
            <div class="col-sm-3 col-xs-12">
              <div class="form-group">
                <label for="street_number">Nr.:</label>
                <input id="street_number" v-validate="{required: true}" v-model="address.corrected_street_no" placeholder="Nr." type="text" class="form-control">
              </div>
            </div>
            <div class="col-sm-4 col-xs-12">
              <div class="form-group">
                <label for="zip_code">{{'shipping_zip_code' | translate}}:</label>
                <input id="zip_code" v-model="address.corrected_zip_code" placeholder="Postleitzahl" v-validate="{required: true}" type="text" class="form-control">
              </div>
            </div>
            <div class="col-sm-8 col-xs-12">
              <div class="form-group">
                <label for="city">{{'place' | translate}}:</label>
                <input id="city" placeholder="Ort" v-validate="{required: true}" v-model="address.corrected_city" type="text" class="form-control">
              </div>
            </div>
            <div class="col-xs-12">
              <div class="form-group">
                <label for="country">{{'country' | translate}}:</label>
                  <select id="country" class="form-control" v-validate="{required: true}" v-model="address.corrected_country">
                    <option v-for="country in ['DE', 'AT', 'CH', 'NL', 'LU']" v-bind:key="country.id" :value="country">
                      {{ country.toLowerCase() | newCountry($store.getters.language) }}
                    </option>
                </select>
              </div>
            </div>
          <div class="col-xs-12">
            <span v-show="errors.any()" class="text-danger pull-right">{{ 'all_fields_required' | translate }}</span><br>
            <span v-show="errors.has('click_collect_email')" class="text-danger pull-right">{{ 'email_bad_format' | translate }}</span>
          </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-xs-6 text-left">
              <a class="btn btn-app btn-outline no-margin" data-dismiss="modal"><i class="fa fa-times"></i>{{ 'cancel' | translate }}</a>
            </div>
            <div class="col-xs-6 text-right">
              <button data-dismiss="modal" :disabled="errors.any()" @click="sendDataToParent();" class="btn btn-app btn-success"><i class="fa fa-save"></i>{{'save' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sde1Active } from '@/sunset-helper'

export default {
  name: 'StoreAddressBasicModal.vue',
  props: {
    addressForModal: {
      type: Object
    },
    prefix: {
      type: String
    }
  },
  data() {
    return {
      address: {}
    }
  },
  methods:{
    sde1Active,
    sendDataToParent() {
      this.$validator.validate()
        .then(result => {
          if (result) {
            this.$emit('sendDataToParent', this.address)
          }
        })
    },
    createVariables() {
      this.address = JSON.parse(JSON.stringify(this.addressForModal))
      this.address.corrected_name = this.address.name;
      this.address.corrected_contact_name = this.address.contact_name;
      this.address.corrected_order_email = this.address.order_email;
      this.address.corrected_contact_email = this.address.contact_email;
      this.address.corrected_click_collect_email = this.address.click_collect_email;
      this.address.corrected_contact_phone = this.address.contact_phone;
      this.address.corrected_erp_store_id = this.address.erp_store_id;
      this.address.corrected_ranking = this.address.ranking;
      this.address.corrected_street = this.address.street;
      this.address.corrected_street_no = this.address.street_no;
      this.address.corrected_zip_code = this.address.zip_code;
      this.address.corrected_city = this.address.city;
      this.address.corrected_country = this.address.country;
    }
  },
  watch: {
    prefix (){
      this.createVariables();
      this.errors.clear();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/Modals/StoreAddressBasicModal.vue